<template>
  <div>
    <div :key="key" v-for="(input, key) in inputs">
      <div class="mb-5" v-if="input.type === 'text'">
        <TextField :data="input" />
      </div>
      <div class="mb-5" v-else-if="input.type === 'textarea'">
        <Textarea :data="input" />
      </div>
      <div class="mb-5" v-else-if="input.type === 'select'">
        <Select :data="input" />
      </div>
      <div class="mb-5" v-else-if="input.type === 'checkbox'">
        <Checkbox :data="input" />
      </div>
      <div class="mb-5" v-else-if="input.type === 'combobox'">
        <Combobox :data="input" />
      </div>
      <div class="mb-5" v-else-if="input.type === 'switcher'">
        <Switcher :data="input" />
      </div>
      <div class="mb-5" v-else-if="input.type === 'radio'">
        <Radio :data="input" />
      </div>
      <div class="mb-5" v-else-if="input.type === 'colorpicker'">
        <ColorPicker :data="input" />
      </div>
      <div class="mb-5" v-else-if="input.type === 'rangeslider'">
        <RangeSlider :data="input" />
      </div>
    </div>
  </div>
</template>

<script>
import Textarea from "./Inputs/Textarea.vue";
import TextField from "./Inputs/TextField.vue";
import Select from "./Inputs/Select.vue";
import Checkbox from "./Inputs/Checkbox.vue";
import Combobox from "./Inputs/Combobox.vue";
import Switcher from "./Inputs/Switcher.vue";
import Radio from "./Inputs/Radio.vue";
import ColorPicker from "./Inputs/ColorPicker.vue";
import RangeSlider from './Inputs/RangeSlider.vue';

export default {
  components: {
    TextField,
    Textarea,
    Select,
    Checkbox,
    Combobox,
    Switcher,
    Radio,
    ColorPicker,
    RangeSlider
  },
  name: "ListInputs",
  props: {
    inputs: {
      required: true
    }
  },
  methods: {
    inputEmit() {
      this.$emit("input", this.inputs);
    }
  },
  created() {
    // this.inputs.forEach((input, key) => {
    //     this.inputs[key].value = ''
    // })
  }
};
</script>

<style>
</style>